var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../user');
require('../fullscreen-loading');
require('../error-modal');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$activateDeviceModal', [
    '$log',
    '$uibModal',
    '$user',
    '$fsloading',
    '$errorModal',

    function $activateDeviceModal($log, $uibModal, $user, $fsloading, $errorModal) {
        function openactivateDeviceModal() {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function activateDeviceCtrl($scope) {
                        $scope.code = '';
                        $scope.errorMsg = null;

                        // $scope Functions
                        $scope.activateDevice = function activate() {
                            $log.debug('Code', $scope.code);

                            if($scope.activateDeviceForm.$valid) {
                                $scope.errorMsg = null;

                                $fsloading.show();

                                $user.activateDevice($scope.code)
                                .catch(function onError(err) {
                                    $fsloading.hide();

                                    if(err.title && err.title === 'Expired') {
                                        $errorModal('It looks like this 4 Digit Login Code has expired. Click below to Login again.', {
                                            buttonLabel: 'Login'
                                        })
                                        .closed.then(function () {
                                            $scope.$dismiss();
                                        });
                                    } else {
                                        $scope.errorMsg = 'Invalid code. Please make sure you typed your code correctly.';
                                    }
                                });
                            }
                        };
                    }
                ],
                backdrop: 'static',
                windowClass: 'activate-device-modal',
                keyboard: false
            });

            return modal;
        }

        return openactivateDeviceModal;
    }
]);
